import { render } from "./ListeOrganisations.vue?vue&type=template&id=d796a58a&ts=true"
import script from "./ListeOrganisations.vue?vue&type=script&lang=ts"
export * from "./ListeOrganisations.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__